import { debounce } from 'debounce';
import { DefaultValues, NavigationType, } from '@/search-for-retail/evaluate/models';
export var InputState;
(function (InputState) {
    InputState["Populated"] = "POPULATED";
    InputState["Cleared"] = "CLEARED";
})(InputState || (InputState = {}));
export const formatTitle = ({ description, low, high, value, type, }) => {
    if (type !== NavigationType.Range) {
        return value || '';
    }
    const formattedLow = low !== null && low !== void 0 ? low : DefaultValues.Unbound;
    const formattedHigh = high !== null && high !== void 0 ? high : DefaultValues.Unbound;
    const rangeString = `${formattedLow} - ${formattedHigh}`;
    return description ? `${description}` : rangeString;
};
export const getNavigationName = (facet) => facet.name || facet.displayName || '';
export const getNavigationDisplayName = (facet) => facet.displayName || facet.name || '';
const sanitizeForKey = (value) => {
    if (value === undefined || value === null)
        return '';
    return String(value)
        .normalize('NFC')
        .replace(/\uFEFF|\u200B|\u200C|\u200D|\u00AD/g, '') // Remove BOM and zero-width characters
        .trim()
        .replace(/\s+/g, '__');
};
export const generateKeyForRefinement = (refinement, id) => {
    if (refinement.value) {
        return `${sanitizeForKey(refinement.value)}-${sanitizeForKey(id)}`;
    }
    return [
        sanitizeForKey(refinement.low),
        sanitizeForKey(refinement.high),
        sanitizeForKey(refinement.description),
        sanitizeForKey(id),
    ].filter(Boolean).join('-');
};
export const generateKeyForNavigation = (facet) => `facet-${sanitizeForKey(getNavigationName(facet))}`;
const normalizeForSearch = (text) => text
    .toLowerCase()
    // Remove accents using Unicode normalization
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove combining diacritical marks
    .trim();
const getSearchableRefinementText = (refinement) => normalizeForSearch(formatTitle(refinement));
const getSearchableNavigationText = (facet) => normalizeForSearch(getNavigationDisplayName(facet));
export const filterRefinementsSync = (navigations, inputValue) => {
    const searchValue = normalizeForSearch(inputValue);
    if (!searchValue)
        return navigations;
    const result = [];
    for (const nav of navigations) {
        const navigationName = getSearchableNavigationText(nav);
        // If navigation name matches, include all refinements
        if (navigationName.includes(searchValue)) {
            result.push(nav);
        }
        else {
            const { refinements } = nav;
            let matchCount = 0;
            let filtered = null;
            for (const refinement of refinements) {
                if (getSearchableRefinementText(refinement).includes(searchValue)) {
                    matchCount++;
                    (filtered !== null && filtered !== void 0 ? filtered : (filtered = [])).push(refinement);
                }
            }
            if (matchCount === refinements.length) {
                result.push(nav); // all matched - reuse original
            }
            else if (matchCount > 0) {
                result.push(Object.assign(Object.assign({}, nav), { refinements: filtered }));
            }
            // none matched
        }
    }
    return result;
};
export const filterRefinementsDebounced = (navigations, onFilteredRefinements, debounceMs = 250) => debounce((inputValue) => {
    const searchValue = normalizeForSearch(inputValue);
    if (!searchValue) {
        onFilteredRefinements(navigations);
        return;
    }
    const result = [];
    for (const nav of navigations) {
        const navigationName = getSearchableNavigationText(nav);
        if (navigationName.includes(searchValue)) {
            result.push(nav);
        }
        else {
            const filteredRefinements = nav.refinements.filter((refinement) => getSearchableRefinementText(refinement).includes(searchValue));
            if (filteredRefinements.length > 0) {
                result.push(Object.assign(Object.assign({}, nav), { refinements: filteredRefinements }));
            }
        }
    }
    onFilteredRefinements(result);
}, debounceMs);
